import filesize from 'file-size';

export function fileSize(sizeInBits: number): string {
  return filesize(sizeInBits).human('jedec');
}

export function fileName(file: File): string {
  return file.name.replace(/\.[^/.]+$/, '');
}
